import React from "react";
import useStyles from "./styles";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import StrikesTable from "../RiskTable/StrikesTable";
import CorruptionTable from "../RiskTable/CorruptionTable";
import InitiativeTable from "../RiskTable/InitiativeTable";
import DrugTable from "../RiskTable/DrugTable";
import WorkforceTurnoverTable from "../RiskTable/WorkforceTurnoverTable";
import ForestLandTable from "../RiskTable/forestLandTable";
import WorkforceTable from "../RiskTable/workforceTable";
import PollutantEmissionTable from "../RiskTable/PollutantEmissionTable";
import RawSteelProductionTable from "../RiskTable/RawSteelProductionTable";
import WorkforceTable1 from "../RiskTable/wrokforceTable1";
import ProcessSafetyMetricsTable from "../RiskTable/ProcessSafetyMetricsTable";
import EmployeeCategoryTable from "../RiskTable/EmployeeCategory";
import EmployeeCategoryTable1 from "../RiskTable/EmployeeCategory2Table";
import GenderRepresentation from "../RiskTable/GenderRepresentation";
import GroupRepresentation from "../RiskTable/GroupRepresentational";
import WorkforceGenderTable from "../RiskTable/workforcegendertables";
import DiversityGroupTable from "../RiskTable/DiversityGroupTable";
import FleetFuelEconomyTable from "../RiskTable/FleetFuelEconomyTable";
import ResidentialMortgageTable from "../RiskTable/ResidentialMortgageTable";
import MortgageResolutionTable from "../RiskTable/MortgageResolutionTable";
import BorrowerTypeTable from "../RiskTable/BorrowerTypeTable";
import ProjectDelaysTable from "../RiskTable/ProjectDelaysTable";

function SasbQuestionnaire({
  handleCheckboxChange,
  handleSingleSelect,
  handleTextInputChange,
  textAnswers,
  selectedValues,
  forestLandTable,
  setForestLandTable,
  corruptionTable,
  setCorruptionTable,
  initiativeTable,
  setInitiativeTable,
  drugTable,
  setDrugTable,
  turnoverTable,
  setTurnoverTable,
  strikesTable,
  setStrikesTable,
  workforceTable,
  setWorkforceTable,
  pollutantEmissionTable,
  setPollutantEmissionTable,
  steelProductionTable,
  setSteelProductionTable,
  processSafetyTable,
  setProcessSafetyTable,
  workforceTable1,
  setWorkforceTable1,
  employeeCategoryTable,
  setEmployeeCategoryTable,
  employeeCategoryTable1,
  setEmployeeCategoryTable1,
  genderRepresentationTabel,
  setGenderRepresentationTabel,
  groupRepresentationTabel,
  setGroupRepresentationTabel,
  workforceGenderTable,
  setWorkforceGenderTable,
  diversityGroupTable,
  setDiversityGroupTable,
  fleetTable,
  setFleetTable,
  mortgageTable,
  setMortgageTable,
  resolutionTable,
  setResolutionTable,
  borrowerTypeTable,
  setBorrowerTypeTable,
  delaysTable,
  setDelaysTable,
}) {
  const classes = useStyles();

  const sasbQuestions = useSelector((state) => {
    const data = state.emission.getStandardsQuestionnaire.data.questions_list;
    return Array.isArray(data) ? data : [];
  });

  const questionDict = {};
  let questionNumber = 1; // Global question counter across sections

  sasbQuestions.forEach(
    ({
      main_section,
      section,
      question,
      question_type,
      options,
      id,
      condition,
      question_id,
    }) => {
      if (!questionDict[main_section]) {
        questionDict[main_section] = {};
      }
      if (!questionDict[main_section][section]) {
        questionDict[main_section][section] = [];
      }
      questionDict[main_section][section].push({
        question,
        question_type,
        options,
        id,
        condition,
        question_id,
      });
    }
  );

  return (
    <div>
      {sasbQuestions.length > 0 && (
        <Grid mb={20}>
          <div className={classes.questionList}>
            {Object.keys(questionDict).map((section, sectionIndex) => (
              <React.Fragment key={sectionIndex}>
                <div className={classes.sectionTitle}>
                  <Typography
                    fontSize={20}
                    fontWeight={550}
                    variant="h3"
                    paddingTop="10px"
                  >
                    {section.toUpperCase()}
                  </Typography>
                </div>
                {Object.keys(questionDict[section]).map(
                  (subSection, subIndex) => (
                    <div key={subIndex}>
                      <Typography
                        fontSize={18}
                        fontWeight={500}
                        variant="h4"
                        paddingTop="10px"
                      >
                        {subSection}
                      </Typography>
                      {questionDict[section][subSection].map(
                        (question, qIndex) => {
                          // Identify if it's a sub-question
                          const isSubQuestion = question.question_id !== "None";
                          // Find the parent meta (if this is a sub-question)
                          const parentMeta = isSubQuestion
                            ? questionDict[section][subSection]?.find(
                                (q) => q.id === question.question_id
                              )
                            : null;

                          // Parent is a label-only prompt (from earlier fix)
                          const parentIsLabelOnly =
                            !!parentMeta &&
                            (!parentMeta.question_type ||
                              String(parentMeta.question_type).trim() === "");

                          // Parent is free-text / number input
                          const parentIsFreeText =
                            !!parentMeta &&
                            [
                              "text",
                              "text field",
                              "short_text",
                              "number_text",
                              "input",
                              "string",
                              "textarea",
                              "number",
                            ].includes(
                              String(parentMeta.question_type).toLowerCase()
                            );

                          const parentIsSingleSelect =
                            !!parentMeta &&
                            [
                              "choose_from_option",
                              "choose from options",
                              "single_select",
                              "radio",
                            ].includes(
                              String(parentMeta.question_type).toLowerCase()
                            );

                          const isConditionSubQuestion =
                            question.condition === "sub_question";

                          const parentAnswer = isSubQuestion
                            ? selectedValues[question.question_id]
                            : null;

                          const descriptiveKeywords = [
                            "manufacturing",
                            "distribution",
                            "transportation",
                            "retail",
                            "product name",
                            "annualised",
                          ];

                          const isDescriptiveSubQuestion =
                            descriptiveKeywords.some((keyword) =>
                              question.question
                                ?.toLowerCase()
                                ?.startsWith(keyword)
                            );

                          const isIfYesChain = questionDict[section][
                            subSection
                          ]?.find(
                            (q) =>
                              q.id === question.question_id &&
                              q.question?.toLowerCase().startsWith("if yes")
                          );

                          const grandParentId = isIfYesChain?.question_id;
                          const grandParentAnswer =
                            selectedValues?.[grandParentId];

                          const shouldRender =
                            !isSubQuestion ||
                            parentAnswer === "Yes" ||
                            (isSubQuestion &&
                              parentAnswer === undefined &&
                              isDescriptiveSubQuestion) ||
                            isConditionSubQuestion ||
                            (isIfYesChain && grandParentAnswer === "Yes") ||
                            (isSubQuestion &&
                              question.question_type === "table" &&
                              parentIsLabelOnly) ||
                            (isSubQuestion && parentIsLabelOnly) ||
                            (isSubQuestion && parentIsFreeText);

                          if (!shouldRender) return null;

                          let displayIndex = !isSubQuestion
                            ? questionNumber++
                            : "";

                          const isOtherSelected =
                            question.question_type ===
                              "multiselect_check_box" &&
                            (selectedValues[question.id]?.includes(
                              "Other (Please specify):"
                            ) ||
                              selectedValues[question.id]?.includes(
                                "Other (Please specify)"
                              ));

                          let subLetter = "";
                          if (
                            isSubQuestion &&
                            (parentIsLabelOnly ||
                              parentIsFreeText ||
                              parentIsSingleSelect)
                          ) {
                            const siblings = questionDict[section][
                              subSection
                            ].filter(
                              (q) => q.question_id === question.question_id
                            );
                            if (siblings.length > 1) {
                              const idxAmongSiblings = siblings.findIndex(
                                (q) => q.id === question.id
                              );
                              subLetter = `${String.fromCharCode(
                                97 + idxAmongSiblings
                              )}. `;
                            }
                          }

                          return (
                            <Grid key={qIndex} className={classes.gridItem}>
                              {question?.question !== "" && (
                                <Typography
                                  fontSize={18}
                                  fontWeight={500}
                                  variant="h3"
                                  paddingLeft={isSubQuestion ? 6 : 4} // Indent sub-questions
                                  paddingBottom={2}
                                >
                                  {displayIndex && `${displayIndex}. `}
                                  {subLetter}
                                  {question?.question}
                                </Typography>
                              )}

                              {/* Answer Inputs */}
                              <Box
                                display="flex"
                                paddingLeft={6}
                                flexWrap="wrap"
                              >
                                {/* Text Fields */}
                                {[
                                  "text",
                                  "Text Field",
                                  "short_text",
                                  "input",
                                  "string",
                                  "textarea",
                                ].includes(question.question_type) && (
                                  <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Enter your answer"
                                    value={textAnswers[question.id] || ""}
                                    onChange={(e) =>
                                      handleTextInputChange(
                                        question.id,
                                        e.target.value
                                      )
                                    }
                                    className={classes.input}
                                    multiline
                                    rows={3}
                                  />
                                )}

                                {["number_text"].includes(
                                  question.question_type
                                ) && (
                                  <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Enter your answer"
                                    value={textAnswers[question.id] || ""}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      );
                                      handleTextInputChange(question.id, value);
                                    }}
                                    inputProps={{
                                      inputMode: "numeric",
                                      pattern: "[0-9]*",
                                    }}
                                    className={classes.input}
                                  />
                                )}

                                {(question?.question_type ===
                                  "choose_from_option" ||
                                  question?.question_type ===
                                    "Choose from Options") &&
                                  question?.options?.map((option, idx) => (
                                    <>
                                      <FormControlLabel
                                        key={idx}
                                        control={
                                          <Checkbox
                                            className={classes.selectCheckbox}
                                            checked={
                                              selectedValues &&
                                              selectedValues[question?.id] ===
                                                option
                                            }
                                            onChange={() =>
                                              handleSingleSelect(
                                                question.id,
                                                option
                                              )
                                            }
                                            value={option}
                                            sx={{
                                              color: "#5A404E !important",
                                              borderWidth: "none",
                                              "&.Mui-checked": {
                                                color: "#8C2148 !important",
                                              },
                                            }}
                                          />
                                        }
                                        label={option}
                                      />
                                      {(
                                        selectedValues[question.id] || ""
                                      ).startsWith("Other (Please specify") &&
                                        option.startsWith(
                                          "Other (Please specify"
                                        ) && (
                                          <TextField
                                            variant="outlined"
                                            placeholder="Please type your Answer"
                                            multiline
                                            rows={3}
                                            value={
                                              textAnswers[
                                                `other-${question.id}`
                                              ] || ""
                                            }
                                            onChange={(e) =>
                                              handleTextInputChange(
                                                `other-${question.id}`,
                                                e.target.value
                                              )
                                            }
                                            className={classes.input}
                                          />
                                        )}
                                    </>
                                  ))}

                                {question.question_type ===
                                  "multiselect_check_box" &&
                                question.question?.trim() ===
                                  "Please specify the types of enforcement actions (fill numbers):" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "16px",
                                    }}
                                  >
                                    {question.options.map((option, idx) => (
                                      <div key={idx}>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              className={classes.selectCheckbox}
                                              checked={
                                                selectedValues[
                                                  question.id
                                                ]?.includes(option) || false
                                              }
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e,
                                                  question.id
                                                )
                                              }
                                              value={option}
                                              sx={{
                                                color: "#5A404E !important",
                                                "&.Mui-checked": {
                                                  color: "#8C2148 !important",
                                                },
                                              }}
                                            />
                                          }
                                          label={option}
                                        />
                                        {selectedValues[question.id]?.includes(
                                          option
                                        ) && (
                                          <TextField
                                            fullWidth
                                            variant="outlined"
                                            placeholder={`Enter value for "${option}"`}
                                            value={
                                              textAnswers[
                                                `other-${question.id}-${option}`
                                              ] || ""
                                            }
                                            onChange={(e) =>
                                              handleTextInputChange(
                                                `other-${question.id}-${option}`,
                                                e.target.value
                                              )
                                            }
                                            className={classes.input}
                                            multiline
                                            rows={3}
                                            style={{
                                              marginLeft: "32px",
                                              marginTop: "6px",
                                            }}
                                          />
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  question.question_type ===
                                    "multiselect_check_box" && (
                                    <div>
                                      {/* Render options in a grid */}
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: `repeat(${
                                            question.options.some(
                                              (option) =>
                                                option.split(" ").length > 6
                                            )
                                              ? 2
                                              : 4
                                          }, 1fr)`,
                                          gap: "16px",
                                          alignItems: "left",
                                          position: "relative",
                                          textAlign: "left",
                                        }}
                                      >
                                        {question.options.map((option, idx) => (
                                          <FormControlLabel
                                            key={idx}
                                            control={
                                              <Checkbox
                                                className={
                                                  classes.selectCheckbox
                                                }
                                                checked={
                                                  selectedValues[
                                                    question.id
                                                  ]?.includes(option) || false
                                                }
                                                onChange={(e) =>
                                                  handleCheckboxChange(
                                                    e,
                                                    question.id
                                                  )
                                                }
                                                value={option}
                                                sx={{
                                                  color: "#5A404E !important",
                                                  "&.Mui-checked": {
                                                    color: "#8C2148 !important",
                                                  },
                                                  marginRight: "8px",
                                                }}
                                              />
                                            }
                                            label={option}
                                          />
                                        ))}
                                      </div>

                                      {/* Render "Other (Please specify):" text field in a new row */}
                                      {((question.options.includes(
                                        "Other (Please specify):"
                                      ) &&
                                        selectedValues[question.id]?.includes(
                                          "Other (Please specify):"
                                        )) ||
                                        (question.options.includes(
                                          "Other (Please specify)"
                                        ) &&
                                          selectedValues[question.id]?.includes(
                                            "Other (Please specify)"
                                          ))) && (
                                        <div
                                          style={{
                                            marginTop: "16px",
                                            width: "100%",
                                          }}
                                        >
                                          <TextField
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Please specify"
                                            value={
                                              textAnswers[
                                                `other-${question.id}`
                                              ] || ""
                                            }
                                            onChange={(e) =>
                                              handleTextInputChange(
                                                `other-${question.id}`,
                                                e.target.value
                                              )
                                            }
                                            className={classes.input}
                                            multiline
                                            rows={3}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  )
                                )}
                                {/* Conditional Table Rendering */}
                                {question.question_type === "table" && (
                                  <Grid width={"100%"} key={question.id}>
                                    {question.instructions?.map(
                                      (instruction, index) => (
                                        <Typography
                                          paddingLeft={6}
                                          paddingY={1}
                                          key={index}
                                        >
                                          {index + 1}. {instruction}
                                        </Typography>
                                      )
                                    )}

                                    {/* Table Rendering */}
                                    {question.condition ===
                                    "table_sasb_aerospace_&_defence_1" ? (
                                      <CorruptionTable
                                        corruptionTable={corruptionTable}
                                        setCorruptionTable={setCorruptionTable}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_forestry_management_1" ? (
                                      <ForestLandTable
                                        forestLandTable={forestLandTable}
                                        setForestLandTable={setForestLandTable}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_airlines_1" ? (
                                      <StrikesTable
                                        strikesTable={strikesTable}
                                        setStrikesTable={setStrikesTable}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_iron_steel_1" ? (
                                      <PollutantEmissionTable
                                        pollutantEmissionTable={
                                          pollutantEmissionTable
                                        }
                                        setPollutantEmissionTable={
                                          setPollutantEmissionTable
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_iron_steel_2" ? (
                                      <WorkforceTable
                                        workforceTable={workforceTable}
                                        setWorkforceTable={setWorkforceTable}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_iron_steel_3" ? (
                                      <RawSteelProductionTable
                                        steelProductionTable={
                                          steelProductionTable
                                        }
                                        setSteelProductionTable={
                                          setSteelProductionTable
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_engineering_&_construction_service_1" ? (
                                      <WorkforceTable
                                        workforceTable={workforceTable}
                                        setWorkforceTable={setWorkforceTable}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_chemicals_1" ? (
                                      <PollutantEmissionTable
                                        pollutantEmissionTable={
                                          pollutantEmissionTable
                                        }
                                        setPollutantEmissionTable={
                                          setPollutantEmissionTable
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_chemicals_2" ? (
                                      <WorkforceTable1
                                        workforceTable1={workforceTable1}
                                        setWorkforceTable1={setWorkforceTable1}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_chemicals_3" ? (
                                      <ProcessSafetyMetricsTable
                                        processSafetyTable={processSafetyTable}
                                        setProcessSafetyTable={
                                          setProcessSafetyTable
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_advertising_&_marketing_1" ? (
                                      <EmployeeCategoryTable
                                        employeeCategoryTable={
                                          employeeCategoryTable
                                        }
                                        setEmployeeCategoryTable={
                                          setEmployeeCategoryTable
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_advertising_&_marketing_2" ? (
                                      <EmployeeCategoryTable1
                                        employeeCategoryTable1={
                                          employeeCategoryTable1
                                        }
                                        setEmployeeCategoryTable1={
                                          setEmployeeCategoryTable1
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_engineering_&_construction_service_1" ? (
                                      <WorkforceTable
                                        workforceTable={workforceTable}
                                        setWorkforceTable={setWorkforceTable}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_chemicals_1" ? (
                                      <PollutantEmissionTable
                                        pollutantEmissionTable={
                                          pollutantEmissionTable
                                        }
                                        setPollutantEmissionTable={
                                          setPollutantEmissionTable
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_chemicals_2" ? (
                                      <WorkforceTable1
                                        workforceTable1={workforceTable1}
                                        setWorkforceTable1={setWorkforceTable1}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_chemicals_3" ? (
                                      <ProcessSafetyMetricsTable
                                        processSafetyTable={processSafetyTable}
                                        setProcessSafetyTable={
                                          setProcessSafetyTable
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_advertising_&_marketing_1" ? (
                                      <EmployeeCategoryTable
                                        employeeCategoryTable={
                                          employeeCategoryTable
                                        }
                                        setEmployeeCategoryTable={
                                          setEmployeeCategoryTable
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_advertising_&_marketing_2" ? (
                                      <EmployeeCategoryTable1
                                        employeeCategoryTable1={
                                          employeeCategoryTable1
                                        }
                                        setEmployeeCategoryTable1={
                                          setEmployeeCategoryTable1
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_biotechnology_1" ? (
                                      <InitiativeTable
                                        initiativeTable={initiativeTable}
                                        setInitiativeTable={setInitiativeTable}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_biotechnology_2" ? (
                                      <DrugTable
                                        drugTable={drugTable}
                                        setDrugTable={setDrugTable}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_biotechnology_3" ? (
                                      <WorkforceTurnoverTable
                                        turnoverTable={turnoverTable}
                                        setTurnoverTable={setTurnoverTable}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_media_&_entertainment_1" ? (
                                      <GenderRepresentation
                                        genderRepresentationTabel={
                                          genderRepresentationTabel
                                        }
                                        setGenderRepresentationTabel={
                                          setGenderRepresentationTabel
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_media_&_entertainment_2" ? (
                                      <GroupRepresentation
                                        groupRepresentationTabel={
                                          groupRepresentationTabel
                                        }
                                        setGroupRepresentationTabel={
                                          setGroupRepresentationTabel
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_software_&_it_services_1" ? (
                                      <WorkforceGenderTable
                                        workforceGenderTable={
                                          workforceGenderTable
                                        }
                                        setWorkforceGenderTable={
                                          setWorkforceGenderTable
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_software_&_it_services_2" ? (
                                      <DiversityGroupTable
                                        diversityGroupTable={
                                          diversityGroupTable
                                        }
                                        setDiversityGroupTable={
                                          setDiversityGroupTable
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_car_rental_&_leasing_1" ? (
                                      <FleetFuelEconomyTable
                                        fleetTable={fleetTable}
                                        setFleetTable={setFleetTable}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_mortgage_finance_1" ? (
                                      <ResidentialMortgageTable
                                        mortgageTable={mortgageTable}
                                        setMortgageTable={setMortgageTable}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_mortgage_finance_2" ? (
                                      <MortgageResolutionTable
                                        resolutionTable={resolutionTable}
                                        setResolutionTable={setResolutionTable}
                                      />
                                    ) : question.condition ===
                                      "table_sasb_mortgage_finance_3" ? (
                                      <BorrowerTypeTable
                                        borrowerTypeTable={borrowerTypeTable}
                                        setBorrowerTypeTable={
                                          setBorrowerTypeTable
                                        }
                                      />
                                    ) : question.condition ===
                                      "table_sasb_solar_technology_&_project_developers" ? (
                                      <ProjectDelaysTable
                                        delaysTable={delaysTable}
                                        setDelaysTable={setDelaysTable}
                                      />
                                    ) : (
                                      <Typography color="error">
                                        No Matching Table Found
                                      </Typography>
                                    )}
                                  </Grid>
                                )}
                              </Box>
                            </Grid>
                          );
                        }
                      )}
                    </div>
                  )
                )}
              </React.Fragment>
            ))}
          </div>
        </Grid>
      )}
    </div>
  );
}

export default SasbQuestionnaire;
